import { render, staticRenderFns } from "./ModalAccessible.vue?vue&type=template&id=7fe4495a&scoped=true"
import script from "./ModalAccessible.vue?vue&type=script&lang=js"
export * from "./ModalAccessible.vue?vue&type=script&lang=js"
import style0 from "./ModalAccessible.vue?vue&type=style&index=0&id=7fe4495a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe4495a",
  null
  
)

export default component.exports